const a = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.75 1H12v6.5H8.75a3.25 3.25 0 1 1 0-6.5ZM13 8V1h3.5a3.5 3.5 0 1 1 0 7H13Zm6.5 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0ZM12 8.75H8.75a3.25 3.25 0 0 0 0 6.5H12v-6.5Zm0 7.75v3.25a3.25 3.25 0 1 1-3.25-3.25H12Z" clip-rule="evenodd"></path></svg>';
export {
  a as default
};
